import { useMatch } from "react-router-dom";

import { LinkStyled } from "./CustomLlink.styled";

const CustomLink = ({ to, children, ...props }) => {
  const link = useMatch(to);
  return (
    <LinkStyled to={to} {...props} className={link ? "active" : ""}>
      {children}
    </LinkStyled>
  );
};

export { CustomLink };
